import React from 'react';

export function Section({ title, icon: Icon, children }) {
  return (
    <div className="bg-white border border-[#E5E5E5] rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)]">
      <div className="flex items-center gap-2 px-5 py-4 border-b border-[#D8DDE6]">
        <Icon size={16} className="text-[#0176D3]" />
        <span className="text-[13px] font-bold text-[#080707]">{title}</span>
      </div>
      <div className="p-5 space-y-4">{children}</div>
    </div>
  );
}

export function Toggle({ checked, onChange, label, description }) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div>
        <div className="text-[13px] font-semibold text-[#080707]">{label}</div>
        {description && <div className="text-[12px] text-[#706E6B] mt-0.5">{description}</div>}
      </div>
      <button
        type="button"
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border-2 border-transparent transition-colors focus:outline-none ${checked ? 'bg-[#0176D3]' : 'bg-[#D8DDE6]'}`}
      >
        <span className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${checked ? 'translate-x-4' : 'translate-x-0'}`} />
      </button>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="block text-[12px] font-semibold text-[#706E6B] mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export const INPUT = 'w-full border border-[#D8DDE6] rounded-[4px] px-3 py-2 text-[13px] text-[#080707] focus:outline-none focus:border-[#0176D3]';
